import { ActionRetry } from 'common/components/monochrome-icons';
import { Button } from 'fronton-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { retryButton, retryButtonContainer, retryButtonIcon } from './retry-button.styles';

export const RetryButton: React.FC<React.HTMLAttributes<HTMLElement>> = ({ onClick }) => {
  const { t } = useTranslation();
  return (
    <div className={retryButtonContainer}>
      <Button
        onClick={onClick}
        className={retryButton}
        kind="regular"
        rounded
        size="l"
        variant="secondary"
        iconOnly
        aria-label={t('ui.buttons.retry')}
      >
        <ActionRetry className={retryButtonIcon} />
      </Button>
    </div>
  );
};
